import React, { Dispatch, SetStateAction } from "react";
import { yupValidators } from "../../../../helpers/yupValidators";
import CustomInputField from "../../../CustomHTMLElements/CustomInputField";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTypedSelector } from "./../../../../hooks/redux-hooks/useTypedSelector";
import { useActions } from "./../../../../hooks/redux-hooks/useActions";
import {
  selectOnlineInvestmentCurrency,
  selectInvestmentCurrentStep,
  selectSelectedInvestment,
} from "../../../../redux/selectors/investmentSelector";
import { selectOnlineInvestment } from "./../../../../redux/selectors/investmentSelector";
import {
  LOCAL_CURRENCY_CODE,
  // USD_CURRENCY_CODE,
} from "../../../../helpers/currencies";
import { apiEndpoints } from "../../../../apis/apiEndpoints";
import { postData } from "../../../../apis/apiMethods";
import {
  selectUserCurrencies,
  selectUserId,
} from "../../../../redux/selectors/userSelector";
import { InvestmentCreation } from "../../../../helpers/generalUtils";
import { handleFormatAmount } from "../../../../helpers/formatAmount";
import { appInsights } from "../../../AppInsight/AppInsight";
import { currenciesSelector } from "../../../../redux/selectors/currenciesSelector";

interface IInvestmentModalStepOne {
  setError: Dispatch<SetStateAction<string>>;
}

const schema = yup.object().shape({
  investmentAmount: yupValidators.investmentAmount,
});

const InvestmentModalStepOne: React.FC<IInvestmentModalStepOne> = ({
  setError,
}) => {
  const currencyList: {
    currencyType: "Foreign" | "Local";
    currencyCode: string;
  }[] = useTypedSelector(selectUserCurrencies);
  const currentStep = useTypedSelector(selectInvestmentCurrentStep);
  const investmentCurrency = useTypedSelector(selectOnlineInvestmentCurrency);
  const investment = useTypedSelector(selectOnlineInvestment);
  const selectedInvestment = useTypedSelector(selectSelectedInvestment);
  const { currency } = useTypedSelector(selectOnlineInvestment);
  const { setInvestmentStep, setOnlineInvestmentInfo, setInvestmentType } =
    useActions();
  const funderId = useTypedSelector(selectUserId);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError: setFormError,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      investmentAmount: investment.amount,
    },
  });

  const minInvestmentAmount: any = Math.min(
    ...selectedInvestment?.interest_ranges.map(
      (range: any) => range.lower_amount
    )
  );
  const maximumInvestmentAmount: any = Math.max(
    ...selectedInvestment?.interest_ranges.map(
      (range: any) => range.upper_amount
    )
  );
  const initiatePaystackPayment = async (amount: number) => {
    const reqPayload = {
      amount: Number(amount),
      currency,
      funder_id: funderId,
    };

    const reqBody = {
      investment_transaction_type_id: InvestmentCreation,
      amount: Number(amount),
      request_payload: JSON.stringify(reqPayload),
    };
    try {
      const res = await postData(
        apiEndpoints.INITIATE_PAYSTACK_PAYMENT,
        reqBody
      );
      setOnlineInvestmentInfo({
        reference: res.internal_transaction_reference,
      });
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: { fileName: "InvestmentModalStepOne" },
      });
    }
  };

  const onSubmit = ({ investmentAmount }: { investmentAmount: number }) => {
    setError("");
    if (investmentAmount < minInvestmentAmount) {
      return setFormError("investmentAmount", {
        type: "manual",
        message: "Amount is not up to minimum investment amount",
      });
    }
    if (investmentAmount > maximumInvestmentAmount) {
      return setFormError("investmentAmount", {
        type: "manual",
        message: "Amount is more than maximum investment amount",
      });
    }

    if (!investmentCurrency) {
      setError("Choose investment currency");
      // Clear error after 3 seconds
      setTimeout(() => setError(""), 3000);
      return;
    }

    if (
      (investmentCurrency === LOCAL_CURRENCY_CODE &&
        selectedInvestment.lcy_locked) ||
      (investmentCurrency === LOCAL_CURRENCY_CODE &&
        selectedInvestment.lcy_locked)
    ) {
      return setError(
        "Sorry, the target investment amount has been raised for this currency. "
      );
    }
    initiatePaystackPayment(handleFormatAmount(String(investmentAmount)));
    setOnlineInvestmentInfo({
      amount: handleFormatAmount(String(investmentAmount)),
    });
    setInvestmentStep(currentStep + 1);
  };
  return (
    <div>
      <h5 className="page-subtitle mb-3">{selectedInvestment?.name}</h5>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-4">
          <p className="form-label">
            What kind of Investment do you want to make?
          </p>
          <div className="alignStepOneBoxes">
            {/* Box for Local Currency  */}
            {selectedInvestment?.lcy_product_id && (
              <div
                className={`box ${
                  investmentCurrency === currencyList[0]?.currencyCode
                    ? "active"
                    : ""
                } ${selectedInvestment.lcy_locked && "disabled"}`}
                onClick={() =>
                  setOnlineInvestmentInfo({
                    currency: currencyList[0]?.currencyCode,
                  })
                }
              >
                <div className="currency">
                  {" "}
                  {selectedInvestment.currencyCode}
                </div>
                <p className="label">
                  {" "}
                  {selectedInvestment.currencyCode} Investment
                </p>
              </div>
            )}
            {/* Box for USD Currency  */}
            {/* {selectedInvestment?.usd_product_id && (
              <div
                className={`box ${
                  investmentCurrency === USD_CURRENCY_CODE ? "active" : ""
                } ${selectedInvestment.usd_locked && "disabled"}`}
                onClick={() =>
                  setOnlineInvestmentInfo({ currency: USD_CURRENCY_CODE })
                }
              >
                <div className="currency">$</div>
                <p className="label">Dollar Investment</p>
              </div>
            )} */}
          </div>
        </div>

        <CustomInputField
          type="number"
          enableSeparator
          defaultValue={getValues("investmentAmount")}
          maxLength={20}
          {...register("investmentAmount")}
          placeholder="e.g. 100,000.00"
          label="Enter Amount"
          errors={errors.investmentAmount}
        />

        <div className="d-flex justify-content-end align-items-center mt-3 flex-wrap">
          <button
            type="button"
            className="btn btn-sm advancly-nobg-btn mr-3"
            onClick={() => setInvestmentType("")}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-sm advancly-white-btn">
            Next
          </button>
        </div>
      </form>
    </div>
  );
};
export default InvestmentModalStepOne;
